// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__yXxiL","checkboxCol":"Table_checkboxCol__396Lh","emailCol":"Table_emailCol__1y69t","actionCol":"Table_actionCol__3yHuh"};